import * as React from 'react';

import './check-group-item.css';
import { Icon } from '@/ui-kit/icon/icon';

interface CheckGroupItem extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  group: string;
  indeterminate: boolean;
  scale: 'small' | 'medium' | 'large';
}

const CheckGroupItem = React.forwardRef<HTMLInputElement, CheckGroupItem>(
  (
    { label, group, scale, disabled, indeterminate, onChange, ...props },
    forwardedRef,
  ) => {
    const ref = React.useRef<HTMLInputElement>(null);

    const [isIndeterminate, setIsIndeterminate] = React.useState(indeterminate);

    React.useImperativeHandle(
      forwardedRef,
      () => ref.current as HTMLInputElement,
    );
    React.useLayoutEffect(() => {
      setIsIndeterminate(indeterminate);
      if (ref.current) {
        ref.current.indeterminate = indeterminate;
      }
    }, [indeterminate]);

    return (
      <div
        className={`check-group-item check-group-item-${scale} ${
          disabled ? 'check-group-item-disabled' : ''
        }`}
      >
        <input
          type="checkbox"
          id={props.id}
          name={group}
          checked={props.checked}
          disabled={disabled}
          ref={ref}
          onChange={
            !isIndeterminate
              ? e => {
                  setIsIndeterminate(e.target.indeterminate);
                  onChange?.(e);
                }
              : () => {}
          }
          {...props}
        />
        {(isIndeterminate || props.checked) && (
          <div className="check-group-item-bullet">
            <Icon
              type={isIndeterminate ? 'indeterminate' : 'check'}
              size={scale}
              color="var(--color_white)"
              onClick={() => {
                if (ref.current) {
                  ref.current.click();
                }
              }}
            />
          </div>
        )}
        <label htmlFor={props.id}>{label}</label>
      </div>
    );
  },
);

export { CheckGroupItem };
